module.exports = __webpack_public_path__ + "static/img/logo-large.bc5ad8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/h5/logo-large.png
// module id = ipuq
// module chunks = 163